export default class ClientPayClassClassificationViewModel {
  constructor({ classificationId, classification } = {}) {
    /**
     * @type {Number}
     */
    this.classificationId = classificationId
    /**
     * @type {String}
     */
    this.classification = classification
  }
}
